import { useState } from 'react'
import { motion } from 'framer-motion'

import HugcareContactModal from './HugcareContactModal'

import ForwardArrow from '../assets/icons/forward-arrow.svg'

export default function HugcareFloatingButton() {
  const [modalOpen, setModalOpen] = useState(false)
  const openModal = () => {
    setModalOpen(true)
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className='sticky z-[100] flex flex-col justify-center gap-20 py-40  w-fit bottom-0 sm:bottom-40 left-[calc(100%-85px)] md:left-[calc(100%-120px)]'
    >
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => {
          alert('팜플렛 다운로드 준비중입니다.')
        }}
        className='flex flex-col gap-4 w-60 h-60 sm:w-80 sm:h-80 button_white shadow-sk'
      >
        <p className='text-body3-medium sm:text-body1-medium text-sk-default text-wrap'>
          팜플렛
          <br /> 다운로드
        </p>
      </motion.button>
      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        className='flex flex-col gap-2 w-60 h-60 sm:w-80 sm:h-80 button_black shadow-sk'
        onClick={openModal}
      >
        <img className='w-16 h-16 sm:w-20 sm:h-20' src={ForwardArrow} alt='' />
        <p className='text-body3-medium sm:text-body1-medium text-sk-white'>문의하기</p>
      </motion.button>
      {modalOpen && <HugcareContactModal setModalOpen={setModalOpen} />}
    </motion.div>
  )
}
